module.exports = __webpack_public_path__ + "img/tousu.4f4bfdb4.svg";